module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "c-footer u-relative u-fit-w u-pad-y-1"
  }, [_c('section', {
    staticClass: "u-vacuum u-marg-x-lg u-marg-t-xxl u-marg-b-xxxl u-pad-b-xl u-marg-x-xs@xs u-marg-t-xl@xs u-marg-b-0@xs"
  }, [_c('div', {
    staticClass: "t-text--md t-lspacing--sm u-valign-top u-inline-block u-w3of16 u-marg-l-w1of16 u-marg-r-w1of16 u-w6of16@lg u-block@md u-marg-b-lg@md"
  }, [_c('img', {
    attrs: {
      "src": _vm.contentGlobal.mainLogo,
      "alt": "Gfinity Elite Series",
      "title": "Gfinity Elite Series",
      "width": "255",
      "height": "70"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "t-text--md t-lspacing--sm u-valign-top u-inline-block u-w3of16 u-marg-r-w1of16 u-w2of16@xxl u-marg-r-w2of16@xxl u-w6of16@lg u-marg-b-lg@lg u-hide@md"
  }, [_c('p', {
    staticClass: "t-text--bold u-uppercase"
  }, [_vm._v(_vm._s(_vm.contentGlobal.taxonomies.footer.about.title))]), _vm._v(" "), _c('p', {
    staticClass: "u-marg-t-lg u-uppercase t-text--xxs u-color--white u-line-height--xl t-lspacing--sm",
    domProps: {
      "innerHTML": _vm._s(_vm.contentGlobal.taxonomies.footer.about.content)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "t-text--md t-lspacing--sm u-valign-top u-inline-block u-w3of16 u-marg-l-w1of16@lg u-w7of16@lg u-fit-w@md u-block@md u-marg-b-lg@md"
  }, [_c('div', [_c('p', {
    staticClass: "t-text--bold u-uppercase"
  }, [_vm._v(_vm._s(_vm.contentGlobal.taxonomies.footer.legal.title))]), _vm._v(" "), _c('ul', {
    staticClass: "o-list--none u-marg-t-xs u-uppercase"
  }, _vm._l((_vm.contentGlobal.taxonomies.footer.legal.links), function(item) {
    return _c('li', [_c('app-text-mask', {
      staticClass: "t-text--sm u-line-height--lg u-relative u-click-area--xxs",
      attrs: {
        "to": _vm.$root.getPageURLFromID(item.pageLabel),
        "text": item.name,
        "class-default": "u-color--gray-text",
        "class-over": "u-color--white"
      }
    })], 1)
  }))]), _vm._v(" "), _c('div', {
    staticClass: "u-marg-t-lg t-lspacing--sm"
  }, [_c('p', {
    staticClass: "t-text--bold u-uppercase"
  }, [_vm._v(_vm._s(_vm.contentGlobal.taxonomies.footer.contact.title))]), _vm._v(" "), _c('ul', {
    staticClass: "o-list--none u-marg-t-xs u-uppercase"
  }, [_c('li', [_c('app-text-mask', {
    staticClass: "t-text--sm u-line-height--lg u-relative u-click-area--xxs",
    attrs: {
      "href": _vm.contentGlobal.taxonomies.footer.contact.link.url,
      "type": "a",
      "text": _vm.contentGlobal.taxonomies.footer.contact.link.name,
      "rel": "nofollow noopener",
      "class-default": "u-color--gray-text",
      "class-over": "u-color--white"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "u-marg-t-lg t-lspacing--sm"
  }, [_c('p', {
    staticClass: "t-text--bold u-uppercase"
  }, [_vm._v(_vm._s(_vm.contentGlobal.taxonomies.footer.connect.title))]), _vm._v(" "), _c('ul', {
    staticClass: "o-list--none u-marg-t-xs u-uppercase u-vacuum"
  }, _vm._l((_vm.contentGlobal.taxonomies.footer.connect.links), function(link) {
    return _c('li', {
      staticClass: "c-link--hoverable u-inline-block u-valign-middle u-marg-r-xxs"
    }, [_c('app-btn-social-link', {
      attrs: {
        "url": link.url,
        "type": link.label
      }
    })], 1)
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "t-text--md t-lspacing--sm u-valign-top u-inline-block u-w3of16 u-w6of16@lg u-marg-l-w1of16@md u-fit-w@md"
  }, [_c('p', {
    staticClass: "t-text--bold u-uppercase"
  }, [_vm._v(_vm._s(_vm.contentGlobal.taxonomies.footer.sitemap.title))]), _vm._v(" "), _c('ul', {
    staticClass: "o-list--none u-marg-t-xs u-uppercase"
  }, _vm._l((_vm.contentGlobal.taxonomies.footer.sitemap.links), function(item) {
    return (_vm.URL.page[item.pageLabel]) ? _c('li', [_c('app-text-mask', {
      staticClass: "t-text--sm u-line-height--lg u-relative u-click-area--xxs",
      attrs: {
        "to": _vm.$root.getPageURLFromID(item.pageLabel),
        "text": item.name,
        "class-default": "u-color--gray-text",
        "class-over": "u-color--white"
      }
    })], 1) : _vm._e()
  }))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-37b94340"}!./src/scripts/components/app-footer/template.html
// module id = 904
// module chunks = 0